import React, { useRef, useState, useEffect } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import * as Yup from "yup";
// import { adminMainUrl } from '../../Config';
import Offcanvas from "react-bootstrap/Offcanvas";
import { adminMainUrl } from "../../../../../Config";
import axios from "axios";
import { customStyles } from "../../../../../HelperFunctions";
import { Select } from "antd";

const EditGroupType = ({
  state_id,
  show,
  handleClose,
  onSuccess,
  token,
  user_id,
  parentData,
  loadingParent,
  loadingGroupType,
  groupTypeData,
  refresh,
  ParentName,
}) => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [parentOptions, setParentOptions] = useState([]);
  let [showLoader, setShowLoader] = useState(false);

  let initialValues = {
    name: "",
    parent_id: "",
  };

  //   useEffect(() => {
  //     if (parentData) {
  //       let arr = [];
  //       parentData.map((val) => {
  //         arr.push({ value: val.id, label: val.name });
  //       });
  //       setParentOptions(arr);
  //     }
  //   }, [parentData]);
  useEffect(() => {
    if (loadingGroupType) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    if (groupTypeData && parentData) {
      formik.setFieldValue("name", groupTypeData?.name || "");

      const parentObj = parentData.find(
        (p) => p.name === groupTypeData?.parent
      );

      formik.setFieldValue("parent_id", parentObj ? parentObj.name : null);
    }
  }, [loadingGroupType, groupTypeData, parentData]);

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      try {
        let config = {
          headers: {
            "auth-token": token,
            user_id: user_id,
          },
        };
        if (state_id) {
          values.id = state_id;
        } else {
          toast.error("ID is required.");
          return;
        }

        setDisableSubmit(true);
        axios
          .put(`${adminMainUrl}/api/account/group-type`, values, config)
          .then((response) => {
            if (response.status == 200) {
              refresh();
              toast.success(response?.data?.msg);
              setDisableSubmit(false);
              // resetForm();
              handleClose();
            } else {
              toast.error(response?.data?.msg);
              setDisableSubmit(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.response.data.msg);
            setDisableSubmit(false);
          });
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        setDisableSubmit(false);
      }
    },
  });

  useEffect(() => {
    if (loadingGroupType) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
    if (groupTypeData) {
      formik.setFieldValue("name", groupTypeData?.name);
      formik.setFieldValue("parent", groupTypeData?.parent);
    }
  }, [loadingGroupType, groupTypeData]);

  const closeButtonRef = useRef(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("GroupType is required"),
  });

  return (
    <Offcanvas
      className="custom-offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Group Type</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="co-12">
              <label htmlFor="name" className="form-label">
                Group Type <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="error">{formik.errors.name}</div>
              ) : null}
            </div>

            {/* select parent name */}

            {/* <div className={`col-12 mt-2`}>
              <div className="">
                <label htmlFor="" className="form-label  mb-0">
                  Parent
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <Select
                    className="custom-selector"
                    showSearch
                    optionFilterProp="label"
                    options={parentData.map((p) => ({
                      value: p.id,
                      label: p.name,
                    }))}
                    value={formik.values.parent_id} // This is now the correct ID (number or null)
                    onChange={(value) =>
                      formik.setFieldValue("parent_id", value)
                    }
                    placeholder="Select Parent"
                    allowClear
                    loading={loadingParent}
                  />
                </div>
              </div>
            </div> */}

            {/* show only parent name */}
            <div className="co-12">
              <label htmlFor="name" className="form-label">
                Parent
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="parent"
                name="parent"
                disabled={true}
                value={ParentName}
              />
            </div>
            
          </div>

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary text-xs"
              type="submit"
              disabled={disableSubmit}
            >
              {disableSubmit ? (
                <i className="fa fa-spinner fa-spin" />
              ) : (
                "Update"
              )}
            </button>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditGroupType;
